
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';


function Msfabricationindustrial() {



  const cardData =
  {
    keyword: 'MS Fabrication Industrial Shade Services ',
    heading: 'Anjali Enterprises: MS Fabrication Industrial Shade Services',
    headingDescription: 'Anjali Enterprises offers specialized MS (Mild Steel) fabrication services for industrial shade solutions, ensuring that your commercial or industrial spaces are well-protected and functional. Our high-quality, durable steel shades are tailored to meet the specific needs of factories, warehouses, and other industrial sites, providing optimal protection and enhancing the overall workspace environment.',

    "topPlaces": [
        {
          "title": "Industrial Steel Shade Fabrication",
          "description": "We specialize in industrial steel shade fabrication, creating custom-built shades that are designed to last. Our steel shades provide superior protection from harsh weather conditions while adding to the overall functionality of your industrial space."
        },
        {
          "title": "MS Industrial Shade Services",
          "description": "Our MS industrial shade services include a wide range of solutions, from custom design to installation. Whether you need to shield work areas, machinery, or outdoor storage, our team will deliver durable, high-performance shades that meet your specific requirements."
        },
        {
          "title": "Steel Shade for Factories",
          "description": "Our steel shades for factories provide essential protection from the sun, rain, and other environmental factors. We offer high-quality, long-lasting steel shades that enhance the safety and productivity of your workforce while protecting machinery and goods."
        },
        {
          "title": "MS Shed Construction",
          "description": "Anjali Enterprises provides MS shed construction services for various industrial needs. Our sheds are built with strong, durable mild steel, ensuring that they withstand the demands of your business while providing shelter for equipment, materials, and workers."
        },
        {
          "title": "Industrial Shade Installation",
          "description": "Our expert team specializes in the precise installation of industrial shades. We ensure that every installation is completed on time and to the highest standards, guaranteeing maximum protection and durability."
        },
        {
          "title": "MS Fabrication Work for Industrial Sheds",
          "description": "We offer expert MS fabrication work for industrial sheds, designing custom-built solutions that cater to your specific needs. Our sheds are ideal for factories, warehouses, and other industrial spaces that require sturdy, reliable protection."
        },
        {
          "title": "Steel Industrial Roof Shades",
          "description": "Our steel industrial roof shades are designed to provide optimal coverage for large spaces, including factory floors, parking lots, and outdoor storage areas. These shades help regulate temperature, reduce direct sunlight, and protect workers and equipment."
        },
        {
          "title": "Industrial Shade Design and Installation",
          "description": "We provide complete design and installation services for industrial shades, ensuring that each project is customized to suit the unique needs of your space. Our team works with you to create functional and aesthetically appealing shade solutions for your industrial environment."
        },
        {
          "title": "MS Fabricated Shade for Commercial Spaces",
          "description": "In addition to industrial solutions, we offer MS fabricated shades for commercial spaces, such as retail outlets, office buildings, and parking structures. Our custom-built shades enhance the aesthetic appeal of your commercial property while providing protection from the elements."
        },
        {
          "title": "Anjali Enterprises Contact Number",
          "description": "Contact Anjali Enterprises at +91 8793220265 for reliable and high-quality MS (Mild Steel) fabrication industrial shade installation services. We specialize in designing and fabricating durable and robust industrial shades that provide excellent protection from weather elements while enhancing the functionality of your industrial space. Get in touch for expert installation and professional service. Serving Pune with top-notch MS fabrication industrial shade solutions tailored to your needs."
        }
      ],
      "tableData": [
        ["- Industrial Steel Shade Fabrication", "- MS Industrial Shade Services"],
        ["- Steel Shade for Factories", "- MS Shed Construction"],
        ["- Industrial Shade Installation", "- MS Fabrication Work for Industrial Sheds"],
        ["- Steel Industrial Roof Shades", "- Industrial Shade Design and Installation"],
        ["- MS Fabricated Shade for Commercial Spaces", "- Anjali Enterprises Contact Number"]
      ],


  "whychoose": [
  {
    "WhyChooseheading": "Durable and Strong Construction",
    "WhyChoosedescription": "Anjali Enterprises specializes in high-quality MS (Mild Steel) fabrication industrial shades that offer superior strength and long-lasting durability. Our shades are built to withstand the harshest weather conditions, including heavy rain, extreme heat, and high winds. Designed with tough materials and engineered for maximum stability, these shades provide reliable protection for your outdoor spaces, warehouses, factories, and other industrial settings. Whether for machinery, outdoor storage, or work areas, our MS industrial shades ensure long-term performance and minimal maintenance."
  },
  {
    "WhyChooseheading": "Custom Solutions for Industrial Needs",
    "WhyChoosedescription": "We understand that every industrial property has unique requirements. That's why we offer fully customizable MS fabrication industrial shades to meet your specific needs. Whether you need shades for machinery, storage areas, parking spaces, or outdoor workstations, our team can design and install a shade solution tailored to your space. We work closely with you to understand your requirements and ensure the final product enhances both the functionality and aesthetics of your industrial property."
  },
  {
    "WhyChooseheading": "Protection from Weather Elements",
    "WhyChoosedescription": "Our industrial shades are expertly designed to provide optimal protection from various weather elements. Whether it's the harsh sun, heavy rain, or dust, our shades create a shield to protect your equipment, vehicles, and employees. This makes them an ideal choice for factories, warehouses, and outdoor storage areas, where safeguarding goods and machinery is crucial. With these shades, your property remains safe and operational no matter the weather conditions, reducing downtime and increasing productivity."
  },
  {
    "WhyChooseheading": "Cost-Effective and Affordable",
    "WhyChoosedescription": "MS fabrication industrial shades offer an affordable solution without compromising on quality. We provide competitive pricing, making them a cost-effective option for businesses looking to invest in long-term protection for their industrial spaces. Our high-quality materials and craftsmanship ensure that the shades last for many years, offering great value for your investment. Whether you're outfitting a small workshop or a large industrial site, we make sure our solutions are within your budget while meeting your exact requirements."
  },
  {
    "WhyChooseheading": "Professional Installation",
    "WhyChoosedescription": "At Anjali Enterprises, we take pride in offering a professional installation process. Our team of experts ensures that every MS fabrication industrial shade is installed with precision and care, adhering to industry standards. From the initial consultation and design to the final installation, we handle every step of the process, ensuring a seamless experience for our clients. With careful attention to detail, we ensure the shades are properly anchored, securely fitted, and operate efficiently, enhancing the safety and functionality of your space."
  },
  {
    "WhyChooseheading": "Low Maintenance",
    "WhyChoosedescription": "Our MS fabrication industrial shades are built to require minimal maintenance. They are designed to be durable and resistant to wear and tear, reducing the need for frequent repairs. With regular cleaning and occasional checks, these shades will remain in excellent condition, providing continuous protection for your industrial site. The low maintenance nature of these shades makes them an ideal choice for businesses looking for hassle-free, long-term solutions without the ongoing costs associated with high-maintenance alternatives."
  },
  {
    "WhyChooseheading": "Versatile and Adaptable",
    "WhyChoosedescription": "MS fabrication industrial shades are incredibly versatile and adaptable, making them suitable for a wide range of industrial settings. Whether you need a shade for a large manufacturing plant, parking lot, outdoor assembly line, or a smaller workspace, our shades can be tailored to meet your needs. Their adaptability allows for integration into various environments, providing both functional protection and enhancing the safety and comfort of your workplace. With flexible design options, these shades are perfect for projects of any size."
  },
  {
    "WhyChooseheading": "Aesthetic Appeal",
    "WhyChoosedescription": "While our primary focus is functionality and protection, we also consider the aesthetic impact of our MS fabrication industrial shades. We offer a range of design options and finishes that can be customized to suit the visual style of your industrial property. Whether you prefer a sleek, modern look or a more classic style, we ensure the shades complement the overall design of your space. Our shades not only enhance the functionality of your workspace but also improve its appearance, contributing to a professional and polished look."
  }
]



  }

  const faqData = [
    {
      question: "What is an MS fabrication industrial shade?",
      answer: "An MS (Mild Steel) fabrication industrial shade is a durable shade structure made from mild steel, designed to provide protection from weather elements such as sunlight, rain, and dust. It is commonly used in industrial settings like factories, warehouses, and outdoor workspaces."
    },
    {
      question: "Can MS fabrication industrial shades be customized?",
      answer: "Yes, we offer fully customizable MS fabrication industrial shades to suit your specific needs. We can design the shade in different sizes, shapes, and finishes to meet the requirements of your property or workspace."
    },
    {
      question: "How do MS fabrication industrial shades benefit my business?",
      answer: "MS fabrication industrial shades provide reliable protection for your machinery, goods, and workers from the elements, enhancing safety and efficiency. They also improve the overall working environment by offering shade and shelter for outdoor operations."
    },
    {
      question: "Are MS fabrication industrial shades resistant to weather conditions?",
      answer: "Yes, our MS fabrication industrial shades are built to withstand harsh weather conditions. They are made from high-quality materials and treated with anti-corrosive coatings, ensuring they remain strong and durable despite exposure to sun, rain, and wind."
    },
    {
      question: "How much do MS fabrication industrial shades cost?",
      answer: "The cost of MS fabrication industrial shades varies depending on factors such as size, design, and customization requirements. Contact us for a free consultation and a customized quote based on your specific needs."
    },
    {
      question: "How long do MS fabrication industrial shades last?",
      answer: "MS fabrication industrial shades are built to last for many years. The use of high-quality materials and construction ensures long-term durability and minimal wear, even in demanding industrial environments."
    },
    {
      question: "Do MS fabrication industrial shades require a lot of maintenance?",
      answer: "MS fabrication industrial shades require minimal maintenance. Regular cleaning and occasional inspections are typically all that is needed to keep them in excellent condition. We also offer maintenance services to ensure your shade continues to perform optimally."
    },
    {
      question: "Are MS fabrication industrial shades suitable for large-scale industrial applications?",
      answer: "Yes, MS fabrication industrial shades are perfect for large-scale applications. They are ideal for factories, warehouses, parking lots, and other outdoor industrial spaces that require large, durable, and weather-resistant shade solutions."
    },
    {
      question: "Can you install MS fabrication industrial shades on an existing structure?",
      answer: "Yes, we can install MS fabrication industrial shades on an existing structure. Our expert team ensures a seamless installation, whether it’s a new build or retrofitting an existing space."
    },
    {
      question: "Why should I choose Anjali Enterprises for MS fabrication industrial shade installation?",
      answer: "Anjali Enterprises is known for delivering high-quality MS fabrication industrial shades with professional installation services. We offer customized, durable, and cost-effective solutions to enhance the protection and functionality of your industrial space."
    }
  ];
  
  const testimonials = [
    {
      name: "Mr. Vinay Sharma",
      text: "We installed MS fabrication industrial shades in our factory, and they’ve been a game-changer. The shades provide excellent protection for our equipment and workers, and the installation was smooth and hassle-free. Highly recommend Anjali Enterprises!"
    },
    {
      name: "Ms. Arti Desai",
      text: "The MS fabrication shades installed in our outdoor warehouse have significantly improved the working conditions for our team. The quality is outstanding, and the installation was completed on time. Anjali Enterprises delivered exactly what we needed!"
    }
  ];
  



  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>{testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: " Anjali Enterprises Contact Information:",
    contactNumbers: [
      "+91 8793220265",

    ],
    email: "info@anjalienterprisesindia.com"
  };


  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "All Types of Aluminium Glass Office Partition",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "All Types of Toughened Glass Work",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Door Partition",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "ACP Cladding Panel Installation",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Aluminium Glass Window",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Soundproof Glass Window",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Aluminium Mosquito Net",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bird Net Installation",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Invisible Grill Installation",
    },
    {
      place: "/images/keyword/10.jpg",
      text: " MS Fabrication Door",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "MS Fabrication Shade",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "MS Fabrication Grill",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "MS Fabrication Slide Door ",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "MS Fabrication Industrial Shade",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "All Types of Industrial Fabrication Work",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "All Types of Furniture Work",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "All Types of Industrial Work",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "All Types of Home Renovation Work",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "All Types of Painting Work",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Foil Ceiling Work",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Electrical Work",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Puff Panel Room ",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "PCC Work & Epoxy Flooring Work ",
    },
  ];


  const images = [
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },
    { src: "/images/home8-images/oil_refienery.jpg", alt: "Image 1" },

  ];



  return (
    <div>

<Helmet>
  <title> MS Fabrication Industrial Shade Services in Pune</title>
  <meta name="description" content="Anjali Enterprises offers MS fabrication industrial shade services in Pune, providing steel shade solutions for factories, commercial spaces, and industrial sheds. Call +91 8793220265 for MS industrial shade design and installation." />
  <meta name="keywords" content="Industrial Steel Shade Fabrication, MS Industrial Shade Services, Steel Shade for Factories, MS Shed Construction, Industrial Shade Installation, MS Fabrication Work for Industrial Sheds, Steel Industrial Roof Shades, Industrial Shade Design and Installation, MS Fabricated Shade for Commercial Spaces" />
  <meta name="robots" content="index, follow" />
  <meta property="og:title" content="Contact: +91 8793220265 | Anjali Enterprises | MS Fabrication Industrial Shade Services in Pune" />
  <meta property="og:description" content="Anjali Enterprises offers MS fabrication industrial shade services in Pune, providing steel shade solutions for factories, commercial spaces, and industrial sheds. Call +91 8793220265 for MS industrial shade design and installation." />
  <meta property="og:image" content="https://anjalienterprisesindia.com/images/ms-fabrication-industrial-shade-service.jpg" />
  <meta property="og:url" content="https://anjalienterprisesindia.com/ms-fabrication-industrial-shade-services" />
  <meta property="og:type" content="website" />
  <meta property="og:site_name" content="Anjali Enterprises" />

  <script type="application/ld+json">
    {`
      {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Anjali Enterprises",
        "description": "Anjali Enterprises offers MS fabrication industrial shade services in Pune, providing steel shade solutions for factories, commercial spaces, and industrial sheds. Call +91 8793220265 for MS industrial shade design and installation.",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Pune, Maharashtra",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411057",
          "addressCountry": "IN"
        },
        "telephone": "+91-8793220265",
        "email": "info@anjalienterprisesindia.com",
        "url": "https://anjalienterprisesindia.com/ms-fabrication-industrial-shade-services",
        "logo": "https://anjalienterprisesindia.com/images/anjali-enterprises-logo.jpg",
        "image": "https://anjalienterprisesindia.com/images/ms-fabrication-industrial-shade-service.jpg",
        "priceRange": "₹10000 - ₹50000",
        "offers": {
          "@type": "Offer",
          "url": "https://anjalienterprisesindia.com/ms-fabrication-industrial-shade-services",
          "priceCurrency": "INR",
          "price": "10000",
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "30"
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Suresh P"
            },
            "datePublished": "2024-05-10",
            "reviewBody": "Anjali Enterprises did an outstanding job with our factory shade. The MS industrial shade they installed is sturdy and perfectly designed for our needs. Very happy with their work!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi S"
            },
            "datePublished": "2024-09-05",
            "reviewBody": "We hired Anjali Enterprises for an industrial shed and shade work at our commercial space. They provided an excellent solution and completed the project on time. Great service!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Anjali Enterprises Service Area",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": "18.5195",
            "longitude": "73.8551"
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://anjalienterprisesindia.com/ms-fabrication-industrial-shade-services"
        },
        "keywords": "Industrial Steel Shade Fabrication, MS Industrial Shade Services, Steel Shade for Factories, MS Shed Construction, Industrial Shade Installation, MS Fabrication Work for Industrial Sheds, Steel Industrial Roof Shades, Industrial Shade Design and Installation, MS Fabricated Shade for Commercial Spaces"
      }
    `}
  </script>
</Helmet>




      {/* Banner */}
      <div className="inner-pages-bnr">
        <img src="images/service-banner.jpg" className="img-responsive" alt="Service-banner-image" />
        <div className="banner-caption">
          <h1 className='text-white'>{cardData.keyword}</h1>
        </div>
      </div>



      <section>
        <div className="" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/14.jpg' className='img-fluid' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#24ABE2', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}

              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {/* {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))} */}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <h3 className='Colo'>Why Choose Anjali Enterprises for {cardData.keyword}  </h3>

              <div id="why-choose-section"
                className='px-2'>


                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>

              <div>
                <h3 className='Colo'>FAQs{cardData.keyword} for Anjali Enterprises</h3>
                <Accordion data={faqData} />
              </div>
              <div className=''>


                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>

              <div className='py-5'>

                <div className="contact-box borderrr py-md-3">
                  <h2>{contactData.heading}</h2>
                  <p>For inquiries, quotes, or assistance with your aluminium glass office partition needs, please contact us:</p>
                  <div className="contact-details">
                    <p><strong className=''>Mobile No:</strong></p>
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold fs-5 darkcolor">
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className=''>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link darkcolor">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4' >

              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>

                );
              })}










              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '1px solid #24ABE2',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                  color: 'white'
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#24ABE2' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 8793220265 " className="d-block  text-white">+91 8793220265 </a>
                        

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@anjalienterprisesindia.com" className=" text-white d-block">
                          info@anjalienterprisesindia.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#24ABE2' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i>

                            Anjali Enterprises:<br />
                            Shop No 7 Vishal Deep Residency M  <br />
                            Perk Nagar Highway, Chandan Nagar<br />
                            Vadgaon Sheri,  (Near NA Bus Stop) Pune <br />
                            Maharashtra 411014
                          </i>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <Gallery images={images} ></Gallery>

              </div>

            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Msfabricationindustrial;